import ViewBase from "../../../../framework/core/mvvm/view_base";
import Utility from "../../../../utility/utility";
import { CountUp } from "../../../../lib/countUp";
import { DayWelFareComponent } from "./day_welfare_comp";
import EventManager from "../../../../manager/event_manager";
import { RedPointModule } from "../../../public/component/redpoint_component";
import { WelfareAnimComp } from "./welfare_anim_comp";

const {ccclass, property} = cc._decorator;

@ccclass
export class DayWelfareView extends ViewBase {

   @property(DayWelFareComponent)
   daywelfarecomp:DayWelFareComponent = null;

   @property([cc.Node])
   btnNode:cc.Node[] = [];//领取0.可领取 1倒计时 2完成

   @property([WelfareAnimComp])
   anim:WelfareAnimComp[] = []

   soundId:number = 0;

   updateDayWelfare(data:any,func:Function){
        this.daywelfarecomp.updateDayWelfare(data,(type)=>{
            if (type == 2) {//活动已经完成
                this.canAwardWelfare(2);
            }else if (type == 1) {//可领取
                this.canAwardWelfare(0);
            }else if (type == 0) {//倒计时中
                this.canAwardWelfare(1);
            }else if (type == 3) {//倒计时结束
                this.canAwardWelfare(0);
            }
        });
    }

    private getGoldNumb(num){
        return (Array(5).join('0') + num).slice(-5);
    }

    startAnimEffect(numb:string){
        let str = this.getGoldNumb(numb)
        let index=str.length;
        let delayTime = 0;
        for (let i = 4; i >= 0; i--) {
            this.anim[i].onStartAnim();
            if (i >= 5-str.length) {
                this.scheduleOnce(()=>{
                    this.anim[i].beginAnim(Number(str[--index]));
                },delayTime+=0.2)
            }
        }
        WelfareAnimComp.playDayWelfareSound('gold_spin',()=>{

        },(id)=>{
            this.soundId = id;
        });
    }

    stopSound(){
        if (this.soundId) {
            WelfareAnimComp.stopDayWelfareSound(this.soundId)
        }
    }

    resetAnim(){
        for (let i = 0; i < 5; i++) {
            this.anim[i].onStartAnim();
            this.unscheduleAllCallbacks();
        }
    }

    canAwardWelfare(tag:number){
        this.isGray(tag)
    }

    isGray(tag:number){
        this.btnNode[0].active = tag == 0;
        this.btnNode[1].active = tag == 1;
        this.btnNode[2].active = tag == 2;
    }
}
